import { commonActions } from "../constants"

const initialState = {
    message: "",
    msgType: "",
    labelVal: [],
    seedingData: [],
    columnData: [],
    filterData: [],
    savedColumnData: [],
    columnLockToggle: false,
    PageSize: "10",
    badgeRecords: {
        complaintCount: 0,
        copsCount: 0,
        customerMasterTypeApprovalCount: 0,
        customerPaymentTypeApprovalCount: 0,
        disassemblyApprovalCount: 0,
        driveflowCount: 0,
        focApprovalCount: 0,
        ppQuotationCount: 0,
        sdQuotationCount: 0,
    },
}
// let msgType: { info: 1, success: 2, error: 3 },

export const common = (state = initialState, action) => {
    switch (action.type) {
        case commonActions.MESSAGE_TEXT:
            return {
                ...state,
                msgType: action.payload?.msgType,
                message: action.payload?.message,
            }
        case commonActions.LABEL:
            return {
                ...state,
                labelVal: action.payload,
            }
        case commonActions.SEEDING_DATA:
            return {
                ...state,
                seedingData: action.payload,
            }
        case commonActions.BADGE_DATA:
            return {
                ...state,
                badgeRecords: action.payload,
            }
        case commonActions.COLUMN_DATA:
            return {
                ...state,
                columnData: action.payload,
            }
        case commonActions.COLUMN_LOCK_TOGGLE:
            return {
                ...state,
                columnLockToggle: action.payload,
            }
        case commonActions.SAVED_COLUMN_DATA:
            return {
                ...state,
                savedColumnData: action.payload,
            }
        case commonActions.SAVED_FILTER_DATA:
            return {
                ...state,
                filterData: action.payload,
            }
        case commonActions.PER_PAGE:
            return {
                ...state,
                PageSize: action.payload,
            }
        default:
            return state
    }
}